import { Logo } from "@caint/design-system";
import { useState } from "react";
import { Field } from "../ui/kit.tsx";

export interface LoginDesktopProps {
  onSignIn: (matricula: string, senha: string) => Promise<string | null>;
  /** Aviso neutro exibido acima do formulário (ex.: sessão expirada). */
  aviso?: string;
}

export function LoginDesktop({ onSignIn, aviso }: LoginDesktopProps) {
  const [matricula, setMatricula] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [entrando, setEntrando] = useState(false);

  const entrar = async () => {
    if (entrando) {
      return;
    }
    setEntrando(true);
    setErro(null);
    const msg = await onSignIn(matricula.trim().toLowerCase(), senha);
    if (msg) {
      setErro(msg);
      setEntrando(false);
    }
  };

  return (
    <div className="dk-login">
      <div className="dk-login-hero">
        <Logo size={48} variant="reverse" />
        <div
          style={{
            fontFamily: "var(--font-mono)",
            letterSpacing: "0.14em",
            fontSize: 12,
            color: "var(--teal-300)",
          }}
        >
          INSTRUMENTO UNIFICADO · v4.0
        </div>
        <h1 style={{ fontSize: 38, fontWeight: 800, letterSpacing: "-0.03em", lineHeight: 1.05, margin: 0 }}>
          Avaliação de maturidade &amp; risco
        </h1>
        <p style={{ color: "rgba(255,255,255,0.72)", fontSize: 16, lineHeight: 1.5, maxWidth: 460 }}>
          CAINT · EMSERH — Comissão para Avaliação Interna da Maturidade. Unidades obstétricas do Maranhão.
        </p>
      </div>
      <div className="dk-login-card">
        <div className="inner">
          <h2 style={{ fontSize: 22, fontWeight: 800, margin: "0 0 18px" }}>Entrar</h2>
          {aviso && (
            <output
              style={{
                display: "block",
                color: "var(--teal-700, #0f766e)",
                background: "var(--teal-50, rgba(45,178,138,0.12))",
                border: "1px solid var(--teal-200, rgba(45,178,138,0.3))",
                borderRadius: 10,
                padding: "9px 12px",
                fontSize: 13,
                margin: "0 0 14px",
              }}
            >
              {aviso}
            </output>
          )}
          <Field id="dk-user" rotulo="E-mail">
            <input
              id="dk-user"
              className="m-input"
              value={matricula}
              onChange={(e) => setMatricula(e.target.value)}
              autoComplete="username"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
              inputMode="email"
            />
          </Field>
          <Field id="dk-pass" rotulo="Senha">
            <input
              id="dk-pass"
              className="m-input"
              type="password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              autoComplete="current-password"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  void entrar();
                }
              }}
            />
          </Field>
          {erro && (
            <p
              role="alert"
              style={{
                color: "var(--danger)",
                background: "var(--danger-soft)",
                borderRadius: 10,
                padding: "9px 12px",
                fontSize: 13,
                margin: "4px 0 12px",
              }}
            >
              {erro}
            </p>
          )}
          <button
            type="button"
            className="m-btn primary"
            style={{ marginTop: 8 }}
            disabled={entrando}
            onClick={() => void entrar()}
          >
            {entrando ? "Entrando…" : "Entrar"}
          </button>
        </div>
      </div>
    </div>
  );
}
